<div class="cardLayout">
    <div class="d-flex flex-row align-items-center psic-gap-4">
        <h4>Latest activities</h4>
        <!-- <div [class.d-none]="!isLoaded" class="spinner-border spinner-border-sm text-primary" role="status"></div> -->
        <app-animation
            [class.d-none]="!isLoaded"
            [src]="'dots_loader.json'"
            [loop]="true"
            [autoplay]="true"
        ></app-animation>
        @if (!isLoaded) {
        <mat-icon
            svgIcon="reload"
            class="reload p1-50-color"
            (click)="retryLatestActivities(); $event.stopPropagation()"
        ></mat-icon>
        } @if(!dcPolicyFailed && !isLoaded && activities.length === 0){
            <lib-alert
                style="width: fit-content"
                [class.d-none]="isLoaded"
                [alertText]="globalMessages.noDataAvailabelMsg"
                [alertTheme]="'neutralBlue'"
                [alertType]="'small'"
            ></lib-alert>
        }
    </div>

    @if (dcPolicyFailed) {
        <lib-alert
            style="width: fit-content"
            [alertText]="globalMessages.serviceMsgError"
            [alertTheme]="'error'"
            [alertType]="'small'"
        ></lib-alert>
    } @else { @if(activities.length > 0){
        <div [class.d-none]="isLoaded" class="d-flex flex-column psic-gap-6">
            @for (activity of displayedActivities; track activity) {
                <div class="activity-item d-flex flex-column psic-p-3 psic-gap-3">
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <p class="alt-bold">{{ activity.category }}</p>
                        <div class="d-flex flex-row align-items-center psic-gap-1 dg_mg-40-color">
                            <mat-icon class="mat-icon-20 dg_mg-60-color" [svgIcon]="'calendar'"></mat-icon>
                            <span class="caption">{{ activity.date }}</span>
                        </div>
                    </div>
                    @if (activity.description) {
                        <p class="alt description">{{ activity.description }}</p>
                    }
                    @if (activity.action) {
                    <div class="action psic-gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.92 12.62C20.8724 12.4972 20.801 12.3851 20.71 12.29L17.71 9.29C17.5217 9.1017 17.2663 8.99591 17 8.99591C16.7337 8.99591 16.4783 9.1017 16.29 9.29C16.1017 9.4783 15.9959 9.7337 15.9959 10C15.9959 10.2663 16.1017 10.5217 16.29 10.71L17.59 12H8C7.73478 12 7.48043 11.8946 7.29289 11.7071C7.10536 11.5196 7 11.2652 7 11V7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6C5.73478 6 5.48043 6.10536 5.29289 6.29289C5.10536 6.48043 5 6.73478 5 7V11C5 11.7956 5.31607 12.5587 5.87868 13.1213C6.44129 13.6839 7.20435 14 8 14H17.59L16.29 15.29C16.1963 15.383 16.1219 15.4936 16.0711 15.6154C16.0203 15.7373 15.9942 15.868 15.9942 16C15.9942 16.132 16.0203 16.2627 16.0711 16.3846C16.1219 16.5064 16.1963 16.617 16.29 16.71C16.383 16.8037 16.4936 16.8781 16.6154 16.9289C16.7373 16.9797 16.868 17.0058 17 17.0058C17.132 17.0058 17.2627 16.9797 17.3846 16.9289C17.5064 16.8781 17.617 16.8037 17.71 16.71L20.71 13.71C20.801 13.6149 20.8724 13.5028 20.92 13.38C21.02 13.1365 21.02 12.8635 20.92 12.62Z"
                                fill="#7D0CF2"
                            />
                        </svg>
                        @if (activity.amount) {
                        <div>
                            {{ activity.description }}
                        </div>
                        }
                    </div>
                    }
                </div>
            } @if (displayedActivities.length < activities.length) {
            <div class="d-flex flex-row justify-content-center align-items-center psic-pb-3 w-100">
                <lib-button
                    [disabled]="false"
                    [buttonType]="'borderless'"
                    [buttonSize]="'medium'"
                    [buttonText]="'Show more'"
                    [libIcon]="'chevron-down'"
                    (callback)="loadMoreActivities()"
                ></lib-button>
            </div>
            } @else if (displayedActivities.length > 5) {
            <div class="d-flex flex-row justify-content-center align-items-center psic-pb-3 w-100">
                <lib-button
                    [disabled]="false"
                    [buttonType]="'borderless'"
                    [buttonSize]="'medium'"
                    [buttonText]="'Show less'"
                    [libIcon]="'chevron-up'"
                    (callback)="showLessActivities()"
                ></lib-button>
            </div>
            }
        </div>
    } }
</div>
